import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';

export const GDRIVE_FILE_PICKER_FETCH_ITEMS_PARAMS =
    'maxResults=1000&fields=files(id,mimeType,name,size,modifiedTime,thumbnailLink)';

export function getGDriveQueryString(location?: string, sort?: AttachmentItemsSort): string {
    let sortColumn = 'modifiedTime';
    if (sort && sort.SortColumn === AttachmentItemsSortColumn.Name) {
        sortColumn = 'name';
    } else if (sort && sort.SortColumn === AttachmentItemsSortColumn.Size) {
        sortColumn = 'quotaBytesUsed';
    }

    const sortOrder =
        sort && sort.SortOrder === AttachmentItemsSortOrder.Ascending ? 'asc' : 'desc';
    const folder = location || 'root';
    return `${GDRIVE_FILE_PICKER_FETCH_ITEMS_PARAMS}&orderBy=folder,${sortColumn} ${sortOrder}&q=mimeType!="application/octet-stream" and trashed=false and "${folder}" in parents`;
}
